export default [
  { label: 'Buy Airtime', value: 'AIRTIME' },
  { label: 'Buy Data Bundle', value: 'DATABUNDLE' }
];
